import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Schema } from '../../../amplify/data/resource';
import { generateClient } from 'aws-amplify/api';

interface Props {
  fundNumber: string;
}

const apiClient = generateClient<Schema>();

export const BankInfo: React.FC<Props> = ({ fundNumber }) => {
  const [bankAccount, setBankAccount] = useState('');

  useEffect(() => {
    const fetchBankAccount = async () => {
      try {
        const response = await apiClient.queries.getBankAccount({
          fundNumber: fundNumber,
        });

        if (response.data && typeof response.data === 'string') {
          setBankAccount(JSON.parse(response.data).body.bankAccount);
        } else {
          console.log('bankAccount is null or not a valid string');
        }
      } catch (error) {
        console.error('Error fetching bank account:', error);
      }
    };

    if (fundNumber) {
      fetchBankAccount();
    }
  }, [fundNumber]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#F3F3F3',
        py: '10px',
        px: '20px',
        borderRadius: '5px',
        flex: 1,
        alignItems: 'flex-start',
        gap: '6px',
      }}
    >
      <img
        src="/assets/file/payments/bank.svg"
        width="80px"
        height="13px"
        alt=""
        style={{ visibility: 'hidden' }}
      />
      <Typography
        fontWeight={'600'}
        fontSize={'12px'}
        fontFamily={'Montserrat'}
        textAlign={'right'}
        dir="rtl"
        sx={{
          unicodeBidi: 'plaintext',
          direction: 'ltr',
        }}
      >
        {bankAccount}
      </Typography>
    </Box>
  );
};
